import { Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { useAllegatiIntervento, useInterventoCliente } from '../../../hooks/interventi'
import { getLabelStatoIntervento } from '../../../utils/utils'
import { AreaClientiRedirect } from '../../AreaClientiRedirect'
import CardBilanciaInfo from '../CardBilanciaInfo'
import CardFlussoRapportoTaratura from '../CardFlussoRapportoTaratura'
import CardFlussoVerificazionePeriodica from '../CardFlussoVerificazionePeriodica'
import CardPrenotazione from '../CardPrenotazione'

export default function InterventoDettaglioCliente() {
  const { id } = useParams()
  const router = useNavigate()
  const intervento = useInterventoCliente(String(id))
  const allegatiIntervento = useAllegatiIntervento(
    {
      intervento: String(intervento?.data?.id),
    },
    { enabled: !!intervento?.data?.id }
  )

  if (intervento.isLoading) {
    return (
      <div className="page">
        <div className="h-100 d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" variant="secondary" />
        </div>
      </div>
    )
  }

  if (intervento.isError) {
    return <AreaClientiRedirect message="Pagina non disponibile" />
  }

  return (
    <div className="page mb-5">
      <div className="row mt-4">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <div
              onClick={() => {
                router(-1)
              }}
              className="p-sm no-link d-flex align-items-center pointer"
            >
              <span className="material-icons text-secondary">event_note</span>
              <span className="ms-2">Lista interventi</span>
            </div>
            <span className="material-icons text-secondary">chevron_right</span>
            <span className="ms-2 p-sm  bg-secondary-light p-2 text-secondary rounded">Dettaglio intervento</span>
          </div>
        </div>
        <div className="col-12 d-flex align-items-center mt-2">
          <h1 className="title">Intervento n° {id}</h1>
        </div>
        <div className="col-12">
          <div className="d-flex align-items-center justify-content-start">
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                backgroundColor:
                  intervento?.data?.stato === 'trasmesso' ||
                  (intervento?.data?.stato === 'eseguito' && intervento.data.tipo_intervento === 'rapporto_taratura')
                    ? '#198754'
                    : '#6c757d',
              }}
            ></div>
            <div className="ms-2">{getLabelStatoIntervento(intervento?.data?.stato)}</div>
          </div>
        </div>
      </div>
      {intervento.data?.stato === 'annullato' && (
        <div className="row mt-2">
          <div className="col-12">
            <div className="alert alert-danger mt-3" role="alert">
              <div className="heading-h4 text-danger">Intervento annullato</div>
              <div className="mt-3 text-black">
                <div className="label-m">Note annullamento</div>
                <div className="p-md mt-2">{intervento?.data?.note_annullamento || 'Nessuna nota'}</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {intervento.data?.stato === 'non_eseguito' && (
        <div className="row mt-2">
          <div className="col-12">
            <div className="alert alert-danger mt-3" role="alert">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <div className="heading-h4 text-danger">Intervento non eseguito</div>
                  <div className="mt-3 text-black">
                    <div className="label-m">Note</div>
                    <div className="p-md mt-2">{intervento?.data?.note || 'Nessuna nota'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row mt-2">
        <div className="col-md-5">
          <CardPrenotazione intervento={intervento} />
          <CardBilanciaInfo intervento={intervento} />
        </div>
        <div className="col-md-7">
          {intervento?.data?.tipo_intervento === 'verifica_periodica' && (
            <CardFlussoVerificazionePeriodica intervento={intervento} allegatiIntervento={allegatiIntervento} />
          )}
          {intervento?.data?.tipo_intervento === 'rapporto_taratura' && (
            <CardFlussoRapportoTaratura intervento={intervento} allegatiIntervento={allegatiIntervento} />
          )}
        </div>
      </div>
    </div>
  )
}
